// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".has-logo{width:375px;margin-left:8px}@media screen and (max-width: 1400px){.has-logo{width:275px}}.nav-bar-header{display:flex;justify-content:space-between}.sub-menu-header{display:flex;margin-right:15%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
